import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../helpers/Constants';

const fetchBankAccountsService = async (source, sourceId) => {
  try {
    return await axios.get(`/api/payment/${source}/${sourceId}/bankaccount`);
  } catch (error) {
    throw new Error(error?.response?.data?.message || UNKNOWN_ERROR);
  }
};

// eslint-disable-next-line import/prefer-default-export
export { fetchBankAccountsService };
